export { StatusBar, setStatusBarStyle, setStatusBarHidden, useVerticalBarEdgeIOS } from './NativeStatusBarWrapper';

//# sourceMappingURL=StatusBar.js.map
